import React from 'react';
import { useAuth } from '../context/AuthContext';
import { LogOut, ClipboardCheck, User } from 'lucide-react';
import { Button } from './ui/button';

const Layout = ({ children }) => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-[#e6d7bf] flex flex-col overflow-x-hidden">
      {/* Header */}
      <header className="bg-[#1c2e52] shadow-lg sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-14 sm:h-16">
            {/* Logo Section */}
            <div className="flex items-center gap-2 sm:gap-3">
              <div className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 bg-[#4b95d1] rounded-lg">
                <ClipboardCheck className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
              </div>
              <div className="flex flex-col">
                <span className="text-lg sm:text-xl font-bold text-white tracking-wide">WAHR</span>
                <span className="text-[10px] sm:text-xs text-[#4b95d1] -mt-1 hidden xs:block">Trainer Checkliste</span>
              </div>
            </div>

            {/* User Section */}
            {user && (
              <div className="flex items-center gap-2 sm:gap-4">
                <div className="flex items-center gap-2 text-white">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 bg-[#4b95d1] rounded-full flex items-center justify-center">
                    <User className="w-4 h-4 text-white" />
                  </div>
                  <span className="text-xs sm:text-sm font-medium hidden sm:block max-w-[100px] truncate">{user.name}</span>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={logout}
                  className="text-[#e6d7bf] hover:text-white hover:bg-[#3e4350] transition-colors duration-200 px-2 sm:px-3"
                >
                  <LogOut className="w-4 h-4 sm:mr-2" />
                  <span className="hidden sm:inline">Abmelden</span>
                </Button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Main Content - Scrollable */}
      <main className="flex-1 w-full max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-4 sm:py-8 overflow-y-auto">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-[#3e4350] mt-auto flex-shrink-0">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-4">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-1 sm:gap-2">
            <p className="text-xs sm:text-sm text-[#e6d7bf] text-center">
              © 2025 WAHR - Privatinstitut
            </p>
            <p className="text-[10px] sm:text-xs text-[#4b95d1]">
              Trainer Wochenplan
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
